import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { useRef, useState } from 'react';
import { AlbumVariationView } from '@zola/svc-web-api-ts-client';
import getSourceElements, { ImageType } from 'libs/client/Image/getSourceElements';

import {
  AlbumDescription,
  AlbumInformation,
  AlbumPricing,
  AlbumType,
  ButtonWrapper,
  PhotoLinkWrapper,
  StyledButtonV3,
  StyledImage,
  StyledPicture,
  TileWrapper,
} from './AlbumStyleTile.styles';
import PricingBreakdownModal from './PricingBreakdownModal';

type AlbumStyleTileProps = {
  images: ImageType;
  featuredImageSrc: string;
  albumInformation: {
    description: string;
    type: string;
    startingPrice: number;
    buildHref: string;
  };
  matrixData: Record<string, Array<AlbumVariationView>>;
};

const AlbumStyleTile: React.FC<AlbumStyleTileProps> = ({
  images,
  featuredImageSrc,
  albumInformation,
  matrixData,
}): JSX.Element => {
  const modalTriggerRef = useRef<HTMLButtonElement>(null);
  const [pricingModalOpened, setPricingModalOpened] = useState(false);

  return (
    <TileWrapper>
      <PhotoLinkWrapper href={albumInformation.buildHref}>
        <StyledPicture>
          {getSourceElements(images.webp, 'webp')}
          {getSourceElements(images.jpg, 'jpg')}
          <StyledImage src={featuredImageSrc} />
        </StyledPicture>
      </PhotoLinkWrapper>

      <AlbumInformation>
        <AlbumType>{albumInformation.type}</AlbumType>
        <AlbumDescription>{albumInformation.description}</AlbumDescription>
      </AlbumInformation>
      <ButtonWrapper>
        <AlbumPricing>From ${albumInformation.startingPrice}</AlbumPricing>
        <StyledButtonV3 component="a" href={albumInformation.buildHref} textTransform={false}>
          Build {albumInformation.type} album
        </StyledButtonV3>
        <LinkV2
          role="button"
          inline
          onClick={() => {
            setPricingModalOpened(true);
          }}
        >
          View pricing breakdown
        </LinkV2>
      </ButtonWrapper>
      {pricingModalOpened && (
        <PricingBreakdownModal
          onClose={() => setPricingModalOpened(false)}
          triggerRef={modalTriggerRef}
          matrixData={matrixData}
        />
      )}
    </TileWrapper>
  );
};

export default AlbumStyleTile;
